$(document).on('turbolinks:load', function() {
    if ($("#conversation-body").length) {
        $('#conversation-body').scrollTop($('#conversation-body')[0].scrollHeight);
    }
});